document.addEventListener("DOMContentLoaded", () => {
  const banner = document.querySelector("[data-line-floating-banner]");
  const closeButton = document.querySelector("[data-line-floating-close]");

  if (!banner) return;

  let isClosed = false;

  const toggleBanner = () => {
    if (isClosed) return;

    if (window.scrollY > 300) {
      banner.classList.add("is-show");
    } else {
      banner.classList.remove("is-show");
    }
  };

  closeButton?.addEventListener("click", () => {
    isClosed = true;
    banner.classList.remove("is-show");
  });

  window.addEventListener("scroll", toggleBanner, { passive: true });

  toggleBanner();
});
